<template>
  <div style="margin-bottom:300px">
    <div class="goods">
      <!-- 把从-product-获取的数据传给GoodsListItem -->
      <goods-list-item
        v-for="item in goods"
        :product="item"
        :key="item.id"
      >
      </goods-list-item>
    </div>
  </div>

</template>
<script>
import GoodsListItem from './GoodsListItem.vue'
export default {
  name: 'GoodsList',
  components: {
    GoodsListItem,
  },
  props: {
    goods: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>
<style scoped>
.goods {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 5px;
  height: 400px !important;
}
</style>
